import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { PublicSettings, Settings } from '@juvare/platform-sdk-react/types';

export function buildSubCategoryValueProvider(settings: Settings | PublicSettings): ValueProvider {
    return {
        type: 'subCategory',
        label: 'Sub-category',
        getValues: (params) => {
            if (typeof params === 'string') {
                const category = settings.notificationCategoryList.find((col) => col.category.key === params);
                const subCategoryValues = category
                    ? category.subCategory.map((sc) => ({
                          value: sc.key,
                          label: `${sc.key}. ${sc.value}`,
                      }))
                    : [];
                return Promise.resolve(subCategoryValues);
            } else {
                return Promise.resolve([]);
            }
        },
    };
}
